<template>
  <div :class="componentStyle.header + '-header'">
    <div class="row">
      <div class="side-nav-wrapper col-lg-2 d-none" :class="{ 'd-lg-block': isSideNav }">
        <side-nav />
      </div>
      <div
        class="main-page-container col-md-12"
        :class="{ 'col-lg-12': isFullWidth, 'col-lg-10': isSideNav }"
      >
        <custom-header v-if="componentStyle.customHeader"></custom-header>
        <header-menu v-if="!componentStyle.customHeader"></header-menu>
        <div :class="['large-header title-wrapper',{'demo':componentStyle.mode=='demo'}]">
          <div class="container">
            <h1 class="title">
              <i class="fo-icon-home"></i>
              {{ $t('menu.home') }}
            </h1>
          </div>
        </div>


        <div class="container">
          <custom-main-content v-if="videos.length > 0 && componentStyle.customMain "></custom-main-content>
          <main-content v-if="(videos.length > 0 || isVideoInfo) && !componentStyle.customMain "></main-content>
          <video-cards v-if="!isVideoInfo && canal" ></video-cards>
        </div>
      </div>
    </div>

    <custom-footer v-if="componentStyle.mode=='demo'" ></custom-footer>
    <page-footer v-if="!isVideoInfo && canal"></page-footer>

  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

import SideNav from './SideNav';
import HeaderMenu from './HeaderMenu';
import MainContent from './MainContent';
import VideoCards from './VideoCards';
import PageFooter from './PageFooter';
import CustomFooter from './CustomComponents/CustomFooter';

import CustomHeader from './Custom/CustomHeader'
import CustomMainContent from './Custom/CustomMainContent'

export default {
  name: 'HomePage',
  metaInfo: {
    title: process.env.META_TITLA,
  },
  components: {
    SideNav,
    HeaderMenu,
    MainContent,
    VideoCards,
    PageFooter,
    CustomFooter,
    CustomHeader,
    CustomMainContent,
  },
  computed: {
    ...mapGetters({
      isFullWidth: 'layout/isFullWidth',
      isSideNav: 'layout/isSideNav',
      componentStyle: 'layout/getComponentStyle',
      currentSkin: 'layout/getCurrentSkin',
      videos: 'videos/getAllVideos',
      playerUrl: 'videos/getPlayerUrl',
    }),
  },
  methods:{
  ...mapActions('videos', ['setCurrentVideo','getCryptedUrl','setCurrentCategory']),

    setisVideoInfo(){
    this.isVideoInfo=false
      this.canal=true
    }
  },

  created(){

    if(this.$route.name == 'canalVideo'){
      this.canal=false
    }
  },

  async mounted(){


    const pathname = this.$route.name;
    console.log("pathname",pathname)

    if (pathname === 'video') {
      let id=this.$route.params.videoId;
      await this.getCryptedUrl(parseInt(id));
      let current = this.playerUrl;
      current.cryptext=current.crypted;
      current.id=parseInt(id);
      this.setCurrentVideo(current);
       this.setCurrentCategory('popular');

      console.log("setCurrentVideo ",current)
    }else
      if (pathname === 'canalVideo') {
        let id=this.$route.params.videoId;
        await this.getCryptedUrl(parseInt(id));
        let current = this.playerUrl;
        let ob={ id : parseInt(id) ,cryptext:current.crypted}
        await this.setCurrentVideo(Object.assign(ob,current));
        this.isVideoInfo=true;

        console.log("setCurrentVideo ",(Object.assign(ob,current)))
      }

    eventHub.$on('isVideoInfo',this.setisVideoInfo);


  },
  data() {
    return {
      isVideoInfo:false,
      canal:true,
    };
  },
};
</script>

<style scoped lang="scss">
.main-page-container {
  overflow-x: hidden;
  min-height: 100vh;
  background-color: var(--background-color,#fafafa);
}

.side-nav-wrapper {
  background-color: #ebeef1;
}

@media (max-width: 575px) {
  .container {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 576px) {
  .container {
    max-width: 100%;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 100%;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  /deep/ .col-lg-3 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1180px;
  }
}

@media (min-width: 1600px) {
  .container {
    max-width: 1400px !important;
  }
}


/* if large header et demo mode */
.large-header .demo {
  background-color: var(--primary-color)!important;
  .title {
    display: none;
  }
}




</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue